
import { Component, Input, EventEmitter, Output, AfterViewInit, ChangeDetectionStrategy }  from '@angular/core';
import { FormBuilder, FormGroup , FormControl } from "@angular/forms";
import { LeoBox } from '../../ui-helper';
import { TicketFee, Money } from '../../models';
import { FeeCollection } from '../../models/ui';

@Component({
	selector: 'fees',
	templateUrl: "./fees.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./fees.scss")]
})
export class Fees implements AfterViewInit{
	@Output() public feeCollectionChange = new EventEmitter<FeeCollection>();

	protected formGroup: FormGroup;
	private _feeCollection: FeeCollection;

	@Input() protected set feeCollection(fc: FeeCollection) {
		this._feeCollection = fc;
		(<FormControl>this.formGroup.controls["bookingFee"]).setValue(fc.bookingFee.fee.value);
		(<FormControl>this.formGroup.controls["handlingFee"]).setValue(fc.handlingFee.fee.value);
		(<FormControl>this.formGroup.controls["ticketFee"]).setValue(fc.ticketFee.fee.value);
		(<FormControl>this.formGroup.controls["systemCharge"]).setValue(fc.systemCharge.fee.value);

	}

	protected get feeCollection() {
		return this._feeCollection;
	}

	constructor(fb: FormBuilder) {
		this.formGroup = fb.group({
			"bookingFee": "",
			"handlingFee": "",
			"ticketFee": "",
			"systemCharge": ""
		})
	}
	public ngAfterViewInit() {
		this.formGroup.valueChanges.debounceTime(400).subscribe(newVal => {
			const fc = FeeCollection.create();
			fc.bookingFee.fee.value = this.parseNumber(newVal["bookingFee"])
			fc.handlingFee.fee.value  = this.parseNumber(newVal["handlingFee"])
			fc.ticketFee.fee.value  = this.parseNumber(newVal["ticketFee"])
			fc.systemCharge.fee.value = this.parseNumber(newVal["systemCharge"])

			// change nur emitten wenn sich einer der werte wirklich geaendert hat
			// ansonsten kommt es zu einem infinite loop von setze die werte im input oben
			// und emitte den change das sich die werte (durch den input) geaendert haben
			if (!FeeCollection.equal(this._feeCollection, fc)) {
				this.feeCollectionChange.emit(fc);
			}
		})
	}

	private parseNumber(str: string): any {
		let numberStr = str;
		if (str && str.replace) {
			numberStr = str.replace(",", ".");
			return parseFloat(numberStr)
		} else {
			return str
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/fee-form/fees.component.ts